import { compose } from 'redux';
import { actions, selectors } from '../../state';
import { STATES } from '../../constants';
import { getVariation } from '@updater-core/lib/optimizely';

const changeMoveSuccessMessage = (state) => {
  const move = selectors.current.move(state);
  const fromAddress = move.fromAddress(state);
  const toAddress = move.toAddress(state);

  return `You've selected your move from ${fromAddress.city}, ${fromAddress.state} to ${toAddress.city}, ${toAddress.state}.`;
};

const CHANGE_MOVE_ERROR_MESSAGE = 'An error occurred selecting your move.';

export default function DashboardConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.DASHBOARD, {
    url: '/dashboard?showHero',
    views: {
      '@': {
        template: '<upd-dashboard></upd-dashboard>',
      },
    },
    title: 'Dashboard',
    analytics: {
      page: 'Dashboard',
    },
    params: {
      // Pass `moveId` in `$stateParams` to change the current move.
      moveId: undefined,
    },
    data: {
      permissions: 'signedIn',
    },
    resolve: {
      guard: (appShell, updStore) => {
        const journeyState = appShell.interactors.journey.getState();
        if (
          appShell.interactors.journey.selectors.hasNewDashboard(journeyState)
        ) {
          updStore.dispatch({ type: 'HALT' });
          // Ensure dashboard doesnt flash by waiting for go and an extra second.
          return appShell.interactors.router
            .go('/utilities-dashboard')
            .then(() => new Promise((resolve) => setTimeout(resolve, 1000)));
        }
      },
    },
    onEnter($stateParams, updStore) {
      const { dispatch, getState } = updStore;
      const state = getState();

      getVariation('Exclusion_Group_Test_0');
      getVariation('Exclusion_Group_Test_1');
      getVariation('Exclusion_Group_Test_2');

      if ($stateParams.moveId) {
        const userId = selectors.current.user(state).id(state);
        const { success, error } = actions.message;

        dispatch(
          actions.user.singleton(userId).update({
            current_move_id: $stateParams.moveId,
          })
        )
          // For now, we'll make a call to get the site-config whenever the move
          // changes so that we have the latest item-definitions and item-definition-phases.
          // We probably want to tackle this another way at some point since this is
          // an expensive call.
          .then(() => dispatch(actions.siteConfig.read()))
          .then(compose(dispatch, success, changeMoveSuccessMessage, getState))
          .catch(compose(dispatch, error, () => CHANGE_MOVE_ERROR_MESSAGE));
      }
    },
  });

  $stateProvider.state(STATES.DASHBOARD_NEW_MOVE, {
    disableBreadcrumb: true,
    scrollTop: true,
    analytics: {
      page: 'Dashboard: New Move',
    },
    data: {
      showHero: true,
    },
  });

  $stateProvider.state(STATES.DASHBOARD_SIGNUP_COMPLETE, {
    disableBreadcrumb: true,
    scrollTop: true,
    analytics: {
      page: 'Dashboard: Sign-Up Complete',
    },
    data: {
      showHero: true,
    },
  });
}
